module.exports = __webpack_public_path__ + "img/champ_de_tournesols.103dad90.webp";